import React, { useState } from "react";
import PaymentModal from "./PaymentModal";
import '../style/component/itemgrid.css';

function ItemGrid({ items, categoryImage, categoryAlt, categoryTitle, categoryDescription, onItemClick, isLoggedIn, setLoginModalOpen }) {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [pendingPurchaseItem, setPendingPurchaseItem] = useState(null);

  const handleBuyClick = (e, item) => {
    e.stopPropagation();
    
    if (!isLoggedIn) {
      setPendingPurchaseItem(item);
      setLoginModalOpen(true);
    } else {
      setSelectedItem(item);
      setIsPaymentModalOpen(true);
    }
  };

  const handleLoginSuccess = () => {
    if (pendingPurchaseItem) {
      setSelectedItem(pendingPurchaseItem);
      setIsPaymentModalOpen(true);
      setPendingPurchaseItem(null);
    }
  };

  React.useEffect(() => {
    if (isLoggedIn && pendingPurchaseItem) {
      handleLoginSuccess();
    }
  }, [isLoggedIn, pendingPurchaseItem]);

  const handleClosePaymentModal = () => {
    setIsPaymentModalOpen(false);
    setSelectedItem(null);
  };

  return (
    <>
      <main className="main-section">
        <div className="category-header">
          <img src={categoryImage} alt={categoryAlt} className="category-img" />
          <div className="category-text">
            <span className="category-title">{categoryTitle}</span>
            <p className="category-desc">{categoryDescription}</p>
          </div>
        </div>

        {items.length === 0 ? (
          <div className="no-results-message">
            <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#888">
              <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
            </svg>
            <h3>No items found</h3>
            <p>Try adjusting your filters to see more results</p>
          </div>
        ) : (
          <div className="pistols-grid">
            {items.map((item) => (
              <div
                key={item.id}
                className="pistol-card"
                onClick={() => {
                  onItemClick(item.name);
                  window.scrollTo(0, 0);
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="pistol-image">
                  <img src={item.img} alt={item.name} />
                </div>
                <div className="card-title">{item.name}</div>
                <div className="card-rating">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={i}
                      xmlns="http://www.w3.org/2000/svg"
                      height="16px"
                      viewBox="0 -960 960 960"
                      width="16px"
                      fill={i < item.rating ? "#FFD166" : "rgba(255,255,255,0.12)"}
                      style={{ marginRight: 4 }}
                    >
                      <path d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z" />
                    </svg>
                  ))}
                </div>

                <div className="card-bottom">
                  <div className="card-price">
                    ${item.price}.00 - ${item.maxPrice}.00
                  </div>
                  <div className="card-buttons">
                    <button 
                      className="add-to-cart-btn"
                      onClick={(e) => handleBuyClick(e, item)}
                    >
                      BUY SKIN
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>

      {selectedItem && (
        <PaymentModal
          isOpen={isPaymentModalOpen}
          onClose={handleClosePaymentModal}
          itemName={selectedItem.name}
          itemPrice={selectedItem.price}
          isLoggedIn={isLoggedIn}
        />
      )}
    </>
  );
}

export default ItemGrid;